export default "__VITE_ASSET__Qs3qosSW__"